exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../node_modules/css-loader/dist/cjs.js!../node_modules/bootstrap/dist/css/bootstrap.min.css"), "");
exports.i(require("-!../node_modules/css-loader/dist/cjs.js!../node_modules/font-awesome/css/font-awesome.min.css"), "");

// Module
exports.push([module.id, "html, body {\n  height: 100%;\n}\n\nlabel input[type=checkbox], label input[type=radio] {\n  margin-right: 0.3rem;\n}", ""]);

